<template>
    <common-content-spacer height="small" class="referral-time-slots-preview">
        <div v-for="(slots, date) in groupSlotsByDate" :key="date" class="selected-slots">
            <div v-if="slots.length">
                <p>
                    <b>{{ formatDate(date) }}</b>
                </p>
                <p v-for="slot in slots" :key="slot.label" class="selected-slots--time">
                    {{ formatTime(slot.startTime) }} - {{ formatTime(slot.endTime) }}
                    <common-icon
                        v-if="showDeleteIcon"
                        name="trash-bin"
                        size="medium"
                        @click="removeItem(slot, date)"
                    ></common-icon>
                </p>
            </div>
        </div>
    </common-content-spacer>
</template>

<script>
    import dayjs from 'dayjs'
    export default {
        props: {
            groupSlotsByDate: { type: Object, required: true },
            showDeleteIcon: { type: Boolean, default: false },
        },
        computed: {},

        methods: {
            formatDate(dateStr) {
                return dayjs(dateStr).format('DD MMMM YYYY')
            },
            formatTime(timeStr) {
                return dayjs(timeStr, 'HH:mm').format('hh:mm A')
            },

            removeItem(slot, date) {
                this.emitEvent({ name: 'remove-item', payload: { slot, date } })
            },
        },
    }
</script>

<style lang="scss" scoped>
    @import 'styles/setup/_variables.scss';

    .referral-time-slots-preview {
        margin-bottom: 30px;
    }

    .selected-slots {
        max-width: 250px;
        &--time {
            display: flex;
            width: 100%;
            justify-content: space-between;

            .icon {
                cursor: pointer;

                &:hover {
                    color: $color--accent-1;
                }
            }
        }
    }
</style>
